<div class="my-5">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
    <sm-dialog #addDialog [dialog]="addSeuilDialog"></sm-dialog>
    <sm-dialog #updateDialog [dialog]="updateSeuilDialog"></sm-dialog>
</div>
